import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { OrderCardTimelineRowComponent } from '../order-card-timeline-row/order-card-timeline-row.component';

export type TTimelineRow = {
  title: string;
  description: string;
};

@Component({
    selector: 'app-order-card-timeline',
    templateUrl: './order-card-timeline.component.html',
    styleUrls: ['./order-card-timeline.component.scss'],
    imports: [CommonModule, OrderCardTimelineRowComponent]
})
export class OrderCardTimelineComponent {
  public title = input<string>("Next steps");
  public rows = input<TTimelineRow[]>();
}